import { contactsService } from "@/services/contactsService";
import type { ContactDeletionImpact } from "@/types/contactDeletion";
import {
  cancelDeferredDelete,
  DEFERRED_DELETE_UNDO_SECONDS,
  scheduleDeferredDeleteWithUndo,
} from "@/lib/deferredDeleteWithUndo";

/** @deprecated Use {@link DEFERRED_DELETE_UNDO_SECONDS} */
export const CONTACT_DELETE_UNDO_SECONDS = DEFERRED_DELETE_UNDO_SECONDS;

function pendingKey(contactIds: string[]): string {
  return `contacts:${[...contactIds].sort().join(",")}`;
}

export function cancelPendingContactPermanentDelete(contactIds: string[]): void {
  cancelDeferredDelete(pendingKey(contactIds));
}

export function scheduleContactPermanentDelete(options: {
  contactIds: string[];
  label: string;
  onScheduled?: () => void;
  onUndo?: () => void;
  onFailed?: () => void;
  onDeleted: (impact: ContactDeletionImpact) => void;
}): void {
  const { contactIds, label, onScheduled, onUndo, onFailed, onDeleted } = options;
  if (contactIds.length === 0) return;

  cancelPendingContactPermanentDelete(contactIds);

  scheduleDeferredDeleteWithUndo({
    idKey: pendingKey(contactIds),
    label,
    onScheduled,
    onUndo,
    onFailed,
    onCommit: async () => {
      const impact = await contactsService.deletePermanently(contactIds);
      onDeleted(impact);
    },
  });
}
